//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

const template =
    `<span with-unison style="line-height: 1">
        <cu-icon
            name="linkout"
            class="styled-link-icon cu-ml-1"
            title="{{ $ctrl.linkTitle }}"
        ></cu-icon>
    </span>`;

import 'app/styled-link-icon/styled-link-icon.less';

angular.module('curalate').component('styledLinkIcon', {
  bindings: {
    linkTitle: '<?',
  },
  template,
});
